import * as XLSX from "xlsx-js-style";

export const MovementsExcel = (data, filters = {}) => {
  if (!Array.isArray(data) || data.length === 0) return;

  const ws = XLSX.utils.aoa_to_sheet([]);

  /* ================= DYNAMIC TITLE ================= */
   const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const formattedDate = filters.Date
        ? filters.Date.split("-").reverse().join("-")
        : "";
  const excelHeading =
    filters.Self === "Y"
                  ? `Movements Report - ${filters.EmployeeID} (${formattedDate})`
                  : filters.Self === "N"
                    ? `Movements Report - Reporting to ${filters.EmployeeID} (${formattedDate})`
                    : `Movements Report - ${filters.EmployeeID} (${monthNames[filters.Month - 1]} - ${filters.Year})`;

  XLSX.utils.sheet_add_aoa(ws, [[excelHeading]], { origin: "A1" });

  ws["A1"].s = {
    font: { bold: true, sz: 16 },
    alignment: { horizontal: "center", vertical: "center" },
    fill: { fgColor: { rgb: "BDD7EE" } }
  };

  /* ===== Merge A1 → F1 ===== */
  ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 5 } }];
  ws["!rows"] = [{ hpt: 28 }];

  /* ================= TABLE DATA ================= */
  const tableData = data.map((row, index) => ({
    "SL#": index + 1,
    Date: row.Date || "",
    "Type": row.Type || "",
    "Source": row.Source || "",
    "Date & Time": row.TranDateTime || "",
    Comments: row.Comments || ""
  }));

  /* ===== Table starts at A3 ===== */
  XLSX.utils.sheet_add_json(ws, tableData, {
    origin: "A3",
    skipHeader: false
  });

  const range = XLSX.utils.decode_range(ws["!ref"]);

  /* ================= TABLE HEADER STYLE ================= */
  const tableHeaderStyle = {
    font: { bold: true },
    alignment: { horizontal: "center", vertical: "center" },
    fill: { fgColor: { rgb: "EEF3FB" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" }
    }
  };

  /* ===== Style table header (A3) ===== */
  for (let C = 0; C <= 5; C++) {
    const cell = XLSX.utils.encode_cell({ r: 2, c: C });
    if (ws[cell]) ws[cell].s = tableHeaderStyle;
  }

  /* ================= ROW STYLES ================= */
  const oddRowStyle = {
    fill: { fgColor: { rgb: "FFFFFF" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" }
    }
  };

  const evenRowStyle = {
    fill: { fgColor: { rgb: "EEF3FB" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" }
    }
  };

  const centerCols = [0, 4, 5];

  /* ===== Style data rows (A4 onwards) ===== */
  for (let R = 3; R <= range.e.r; R++) {
    const baseStyle = R % 2 === 0 ? evenRowStyle : oddRowStyle;

    for (let C = 0; C <= 5; C++) {
      const cell = XLSX.utils.encode_cell({ r: R, c: C });
      if (!ws[cell]) continue;

      ws[cell].s = {
        ...baseStyle,
        alignment: {
          horizontal: centerCols.includes(C) ? "center" : "left",
          vertical: "center",
          wrapText: true
        }
      };
    }
  }

  /* ================= COLUMN WIDTH ================= */
  ws["!cols"] = [
    { wch: 6 },   // SL#
    { wch: 16 },  // Name
    { wch: 16 },  // Check In
    { wch: 22 },  // Check Out
    { wch: 22 },  // Worked Hours
    { wch: 22 }   // Status
  ];

  /* ================= EXPORT ================= */
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Movements");
  XLSX.writeFile(wb, "Movements.xlsx");
};

export default MovementsExcel;
